package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("RefreshPlanStatisticsRequest")
data class RefreshPlanStatisticsRequest(
    @JsName("publicPlanId")
    val publicPlanId: String
)